import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FiArrowUp, FiArrowDown } from "react-icons/fi";
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import * as jobsActions from '../../Redux/Actions/jobs';
import { toastMessage } from '../../utils/toast';
import { useSortableData } from '../../utils/sortableData';
import { clearSession } from '../../utils/initiate';
// import { getParams, dateTimeFormat, useOnClickOutside } from '../../utils';
import Warning from '../Ui/400';
import ReactPaginate from 'react-paginate';
import '../../assets/table.css';
import DataCount from '../../utils/dataCount';
import { setJobIdFilter, setMobileNumberFilter, reset, setClearFilterFlag } from '../../Redux/Reducers/customerJobReportsFilter';

const CustomerJobReport = ({ history }) => {

    let itemsPerPage = 10;
    const [data, setData] = useState([]);
    const [type, setType] = useState('');
    // const [filterJobID, setFilterJobID] = useState('');
    // const [filterMobileNumber, setFilterMobileNumber] = useState('');
    const [filterCustomerName, setFilterCustomerName] = useState(''); //need to change with Email
    const [loading, setLoading] = useState(false);
    const [errStatus, setErrStatus] = useState(200);
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    // const [filter, setFilter] = useState(0);

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const userData = useSelector(({ User }) => User.data);
    const { jobIdState, mobileNumberState, clearFilterFlag } = useSelector((state) => state.customerJobReportsFilter);

    const handleGetAllCustomerInformation = () => {
        setLoading(true);
        let payload = {
            jobID: jobIdState,
            customerMobileNumber: mobileNumberState
        };
        jobsActions.getCustomerInfoReport(payload).then(res => {
            if (res && res.data) {
                let jobData = [];
                res.data.map((form, index) => jobData.push({ 'sno': index + 1, ...form }));
                setData(jobData);
            } else {
                setData([]);
                toastMessage('error', (res && res.message) || `Unable to load the jobs`);
            }
            setLoading(false);
            setType('');
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
    };

    const { items, requestSort, sortConfig } = useSortableData(data);

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(items.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(items.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, items]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % data.length;
        setItemOffset(newOffset);
    };

    const filterHandler = () => {
        if(jobIdState || mobileNumberState) {
          dispatch(setClearFilterFlag(clearFilterFlag + 1));
        }
    } 

    useEffect(() => {
        handleGetAllCustomerInformation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clearFilterFlag]);

    if (errStatus === 400) {
        return <Warning history={history} />
    }

    return (
        <>
            {(type === '') && <div className="container-fluid">
                <div className="page-title-box">
                    <h4 className="page-title my-2">{t("customerJobReport.title")}</h4>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-xxl-12">
                        <div className="card card-custom card-stretch gutter-b">
                            <div className="card-body py-3">
                                <div className="tab-content">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="me-3" style={{ width: '100%' }}>
                                                <label className="mb-1 ms-1 me-3">{t("customerJobReport.filter.jobID")}</label>
                                                <input placeholder={t("customerJobReport.filter.jobIDPlaceholder")} type="number" className="form-control me-3" name="Filter ID" value={jobIdState} onChange={e =>dispatch(setJobIdFilter(e.target.value))} />
                                            </div>
                                            <div className="me-3" style={{ width: '100%' }}>
                                                <label className="mb-1 ms-1 me-3">{t("customerJobReport.filter.mobileNumber")}</label>
                                                <input placeholder={t("customerJobReport.filter.mobileNumberPlaceholder")} type="number" className="form-control me-3" name="Filter ID" value={mobileNumberState} onChange={e => dispatch(setMobileNumberFilter(e.target.value))} />
                                            </div>
                                            <div className="d-flex align-items-end" style={{whiteSpace: 'nowrap'}}>
                                                <button onClick={filterHandler} type="button" className="d-flex me-3 px-4 align-items-center btn btn-primary font-weight-bold" >{t("jobsManagement.filters.filter")}</button>
                                            </div>
                                            <div className="d-flex align-items-end" style={{ whiteSpace: 'nowrap' }}>
                                                <button onClick={() => dispatch(reset())} type="button" className="px-5 d-flex align-items-center btn btn-primary font-weight-bold" >{t("customerJobReport.filter.clearFilters")}</button>
                                            </div>
                                        </div>
                                    </div>
                                    {loading ? <Loader type="ThreeDots" color="#ad1a5f" height={40} width={40} style={{ textAlign: 'center', marginBottom: '50px' }} />
                                        : <div className="table-responsive" style={{ width: '100%', overflowX: 'scroll' }}>
                                            <table className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg">
                                                <thead>
                                                    <tr className="text-left" >
                                                        <th className="c-pointer pl-7" style={{ width: '60px' }} onClick={() => requestSort('sno')}>
                                                            <span className={(sortConfig && (sortConfig.key === 'sno')) ? "text-secondary" : "text-dark-75"}>{t("customerJobReport.manageInformation.sNO")} {(sortConfig && (sortConfig.key === 'sno')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span>
                                                        </th>
                                                        <th style={{ width: '100px' }}><span className="text-dark-75">{t("customerJobReport.manageInformation.jobID")}</span></th>
                                                        <th style={{ width: '100px' }}><span className="text-dark-75">{t("customerJobReport.manageInformation.processName")}</span></th>
                                                        <th style={{ width: '100px' }}><span className="text-dark-75">{t("customerJobReport.manageInformation.departmentName")}</span></th>
                                                        <th style={{ width: '100px' }}><span className="text-dark-75">{t("customerJobReport.manageInformation.masterProcessName")}</span></th>
                                                        <th style={{ width: '100px' }}><span className="text-dark-75">{t("customerJobReport.manageInformation.cutomerName")}</span></th>
                                                        <th style={{ width: '100px' }}><span className="text-dark-75">{t("jobsManagement.manageJobs.referenceName")}</span></th>
                                                        <th style={{ width: '100px' }}><span className="text-dark-75">{t("customerJobReport.manageInformation.cspStaff")}</span></th>
                                                        <th style={{ width: '150px' }}><span className="text-dark-75">{t("customerJobReport.manageInformation.jobStatus")}</span></th>
                                                        <th style={{ width: '170px' }}><span className="text-dark-75">{t("customerJobReport.manageInformation.totalAmount")}</span></th>
                                                        <th style={{ width: '170px' }}><span className="text-dark-75">{t("customerJobReport.manageInformation.paymentDate")}</span></th>
                                                        <th style={{ width: '170px' }}><span className="text-dark-75">{t("customerJobReport.manageInformation.createdTime")}</span></th>
                                                        <th style={{ width: '170px' }}><span className="text-dark-75">{t("customerJobReport.manageInformation.updatedTime")}</span></th>
                                                        <th style={{ width: '100px', position: 'sticky', left: '0px', zIndex: '40' }}><span className="text-dark-75">{t("customerJobReport.manageInformation.action")}</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {currentItems.map(({ sno, id, process, department, masterProcess, customerName, cspStaff, jobStatus, totalAmount, paymentDate, createdTime, updatedTime, referenceName }) => {
                                                        let statusClass = (jobStatus.toLowerCase() === 'completed') ? 'success' : ((jobStatus.toLowerCase() === 'cancelled') ? 'danger' : 'warning');
                                                        return (
                                                            <tr key={sno}>
                                                                <td className="pl-7">
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{sno}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{id}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{process}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{department}</span>
                                                                </td>
                                                                <td >
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{masterProcess}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{customerName}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{referenceName ? referenceName : '-'}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{cspStaff}</span>
                                                                </td>
                                                                <td style={{ whiteSpace: 'nowrap' }}>
                                                                    <span className={"p-2 badge badge-outline-" + statusClass} style={{ borderRadius: '3px', width: 'auto' }}>{jobStatus}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{totalAmount}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{paymentDate}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{createdTime}</span>
                                                                </td>
                                                                <td>
                                                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{updatedTime}</span>
                                                                </td>
                                                                <td className="pr-0">
                                                                    <p onClick={() => userData.Role === 'CALLCENTERSUPPORT' ? history.push(`/customer_job_reports/${id}`) : history.push(`/jobs/${id}`)} className="btn btn-info font-weight-bolder font-size-sm me-2">{t("customerJobReport.manageInformation.more")}</p>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                            {(pageCount > 1) && <ReactPaginate
                                                breakLabel="..."
                                                nextLabel=">"
                                                previousLabel="<"
                                                onPageChange={handlePageClick}
                                                pageRangeDisplayed={5}
                                                pageCount={pageCount}
                                                pageClassName="page-item"
                                                pageLinkClassName="page-link"
                                                previousClassName="page-item"
                                                previousLinkClassName="page-link"
                                                nextClassName="page-item"
                                                nextLinkClassName="page-link"
                                                breakClassName="page-item"
                                                breakLinkClassName="page-link"
                                                containerClassName="pagination"
                                                activeClassName="active"
                                                renderOnZeroPageCount={null}
                                            />}
                                            {(data.length === 0) && <p className="text-center mt-5 mb-5">{t("jobsManagement.noDataAvailable")}</p>}
                                        </div>}
                                        {data.length>0 && <DataCount itemOffset={itemOffset} items={items}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    );
};

export default CustomerJobReport;